export default __webpack_public_path__ + "static/media/shared-earth-vertical.28d5846d.svg";